import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  .date {
    font-size: 14px;
  }
`;

export const FiltersContainer = styled.div`
  display: grid;
  gap: 16px;
  grid-template-columns: 1fr 1fr 200px 1fr;
  align-items: end;
  min-width: 0;

  > * {
    min-width: 0;
    max-width: 100%;
  }

  @media (max-width: 600px) {
    grid-template-columns: minmax(0, 1fr);
    gap: 12px;

    > * {
      width: 100%;
    }

    button {
      width: 100%;
      min-width: 0;
      padding: 0 16px;
    }
  }
`;

export const Row = styled.tr <{ status?: Number }> `
  td {
    font-weight: ${({ status }) => status ? 600 : 400};
  }

  color: ${({ theme, status }) => status === 5
    ? theme.colors.attention
    : status === 7
      ? theme.colors.succesful : ''
  };
`;

export const Td = styled.td`

  `;
